import { render, staticRenderFns } from "./ContainerInstrument.vue?vue&type=template&id=0c06d269&scoped=true"
import script from "./ContainerInstrument.vue?vue&type=script&lang=js"
export * from "./ContainerInstrument.vue?vue&type=script&lang=js"
import style0 from "./ContainerInstrument.vue?vue&type=style&index=0&id=0c06d269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c06d269",
  null
  
)

export default component.exports